/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Roles routes
 */

// Pages
import RolesManagement from '@nephro/pages/Roles/RolesManagement';
import RolesCreation from '@nephro/pages/Roles/RolesCreation';
import RolesViewEdit from '@nephro/pages/Roles/RolesViewEdit';
import RolePermissions from '@nephro/pages/Roles/RolePermissions';

const pathStart = '/main/rol-management';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: RolesManagement,
    exact: true
  },
  {
    id: 'create',
    path: `${pathStart}/create`,
    isProtected: true,
    component: RolesCreation,
    exact: true
  },
  {
    id: 'view',
    path: `${pathStart}/view/:id`,
    isProtected: true,
    component: RolePermissions,
    exact: true
  },
  {
    id: 'edit',
    path: `${pathStart}/edit/:id`,
    isProtected: true,
    component: RolesViewEdit,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
